import React from 'react';
import { AlertCircle, Check, Info, X } from 'lucide-react';
import './toast.css';

const ICONS = {
  success: Check,
  error: X,
  warning: AlertCircle,
  info: Info,
};

/**
 * Shared toast chrome — white card, circular status icon (matches “Draft saved”).
 */
export function ToastCard({ message, type = 'info', visible = true }) {
  const Icon = ICONS[type] || ICONS.info;
  return (
    <div
      className={`q2c-toast q2c-toast--${type}${visible ? ' q2c-toast--visible' : ' q2c-toast--hidden'}`}
      role="status"
      aria-live="polite"
    >
      <span className="q2c-toast-icon" aria-hidden="true">
        <Icon size={14} strokeWidth={2.5} />
      </span>
      <span className="q2c-toast-message">{message}</span>
    </div>
  );
}
